(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import { useTranslation } from "react-i18next";
import ErrorPlaceholder from "../ErrorPlaceholder";

const Page404 = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ErrorPlaceholder, {
    title1: t("NOT"),
    title2: t("FOUND"),
    desc: t("The page you are looking for does not exist")
  });
};

__signature__(Page404, "useTranslation{{ t }}", () => [useTranslation]);

const _default = /*#__PURE__*/React.memo(Page404);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Page404, "Page404", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Page404/Page404.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Page404/Page404.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();